/*=================================================
    summary: 學生作答 選擇題型 下方內容 ChoiceContent
             練習 聽一聽                LUSeqNo: 13       選擇題型          
             練習 讀一讀                LUSeqNo: 15
             複習 聽力理解              LUSeqNo: 20
             複習 閱讀練習              LUSeqNo: 21

             Practice Listening
             Practice Reading Comprehension
             Review Listening
             Review Reading

             此單元 沒有 Save功能，不需要用Temp Answer List

    remarks: 000 Tim 2022/01/05 Create
             001 Tim 2022/01/13 增加 讀取 ContentText 圖片 流程
             002 Tim 2022/01/14 串接 LanguageChangeHandler 流程
             003 Tim 2022/03/11 補上 BlockedInstructor 機制
=================================================*/
import React, { useEffect, useState, useRef, useContext } from 'react'
import cssChoiceContent from './ChoiceContent.module.scss'

import { ExecuteActionEnum, TestSheetModeEnum } from '../CompositionContent/CompositionContent'

import { LUCacheContext } from '../../../LearningUnit.js'
import { TestSheetContext } from '../ChoiceMain/ChoiceMain'

// import * as utilAudioLibs from '../../../../Utils/TTS/AudioLibs'

import parse from 'html-react-parser'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Constant
const COMP_NAME = "ChoiceContent"

const IMAGE_DISPLAY_WIDTH = 700
// #endregion Constant

// #region Enumeration
const AnswerTypeEnum = {
    "Text": 1,
    "Image": 2
}
// #endregion Enumeration

// #region State Member Variables
let marrStateAudioStatus = []
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mstrBookCatID = ""
let mstrLUKey4LUCachedContext = "" // 用於從LUCacheContext 取出 Cache的LU資料時 指出此LU時所需的Key
let mstrImagePrefix = ""
let mintClassID = -1

let mobjDisplaySubSubSection = {
    "NameEN": "",
    "NameCN": ""
}
let marrContentData = []
let mintSQIndex4PreloadThumbnailImage = 0
let mintImgIndex4PreloadThumbnailImage = 0
let mintSQIndex4PreloadOriginalImage = 0
let mintImgIndex4PreloadOriginalImage = 0
let mintSQIndex4OriginalAnsImg = 0
let mintCQIndex4OriginalAnsImg = 0
let mintImgIndex4OriginalAnsImg = 0

let marrDisplayQuestion = []
let mintPlayAudioIndex = -1
// #endregion Member Variables

function ChoiceContent(props)
{
    console.log(COMP_NAME + ".Begin:", props)
    console.log(COMP_NAME + ".props.LUInfo: ", props.LUInfo)
    console.log(COMP_NAME + ".props.LessonID: ", props.LessonID)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [audioStatusArray, setAudioStatusArray] = useState([])
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region Init Context Ref
    // History, Temp, 都是 Cached 在這裏
    let mobjLUCacheContext = useContext(LUCacheContext)
    console.log("mobjLUCacheContext: ", mobjLUCacheContext)

    let mobjTestSheetContext = useContext(TestSheetContext)
    console.log("mobjTestSheetContext: ", mobjTestSheetContext)
    // #endregion Init Context Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
        mblnInitialized = true

        if (
            (typeof (window.gSession.Acc.Class) !== 'undefined') &&
            (window.gSession.Acc.Class !== null) &&
            (window.gSession.Acc.Class.length > 0) &&
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID !== null) &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            mintClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        }
        else
        {
            mintClassID = -1
        }

        mstrBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
    } // end of if (!mblnInitialized) 
    // #endregion First Launch

    // Update audioStatusArray
    useEffect(() => {
        marrStateAudioStatus = audioStatusArray

        console.log(COMP_NAME + ".Update audioStatusArray: marrStateAudioStatus: ", marrStateAudioStatus)
    }, [audioStatusArray])

    // #region useEffect
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
            window.AudioLibs.StopAudio()

            mblnInitialized = false
            mobjDisplaySubSubSection = {
                "NameEN": "",
                "NameCN": ""
            }
            marrDisplayQuestion = []
            mintPlayAudioIndex = -1
            mintClassID = -1
            
            mobjCallParam = null
            setUpdateDataTime(0)
            setAudioStatusArray([])
        }
    }, [props.LUInfo])
    // #endregion useEffect

    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function PaintedMe()
    {
        // console.log(COMP_NAME + ".PaintedMe: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PaintedMe BEGIN")

        RegisterExecuteChoiceContentAction()
        RegisterLanguageChangeHandler()
        RegisterAudioEvent()

        mstrLUKey4LUCachedContext = "LU" + props.LUInfo.LUCatSeqNo // 用於Cache LU資料時 指出此LU的Key

        mstrImagePrefix = window.Globals.GetResourcePrefix(mstrBookCatID, props.LessonID, window.gResourceTypeEnum.Image)
        
        // 練習 讀一讀                LUSeqNo: 15
        if (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)
        {
            // 整理 標題資訊 (SubSubSection)
            mobjDisplaySubSubSection.NameEN = props.SubSectionDef.SubSubSection[0].Name
            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MajorName
            }
            else
            {
                mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MinorName
            }
        } // end of if (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)

        InitContentDataProcessBegin()

        console.log(COMP_NAME + ".PaintedMe END")
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 按下 歷史紀錄 按鈕
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function HistoryOnTapHandler()
    {
        // console.log(COMP_NAME + ".HistoryOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".HistoryOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus)
        mintPlayAudioIndex = -1

        console.log("mobjLUCacheContext:", mobjLUCacheContext)
        let objCallbackData = {
            "Action": "HistoryWindowOpen",
            "CallbackRef": HistoryWindowCallback,
            "LessonID": props.LessonID,
            "AssigementHistoryList": mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList,
            "AssignmentTempAns": null
        }
        props.CallbackRef(objCallbackData)
    } // end of HistoryOnTapHandler

    /*===========================================
    summary: 按下 重新開始 or 繼續 資料 按鈕
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function TryAgainOnTapHandler()
    {
        // console.log(COMP_NAME + ".TryAgainOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".TryAgainOnTapHandler BEGIN")  
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus)
        mintPlayAudioIndex = -1

        let enumTestSheeMode = TestSheetModeEnum.New

        ChangeTestSheetMode(enumTestSheeMode, 0)
    } // end of TryAgainOnTapHandler

    /*===========================================
    summary: 按下 送出作答資料 按鈕
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        // console.log(COMP_NAME + ".SubmitOnTapHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".SubmitOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.AudioLibs.StopAudio()
        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus)
        mintPlayAudioIndex = -1

        ExecuteSubmitAnswer()
    } // end of SubmitOnTapHandler

    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioFN, QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        let intAudioStatus = window.gAudioStatusEnum.Playing
        if (arrAudioStatus[QuestionIndex] === window.gAudioStatusEnum.Paused)
        {
            window.AudioLibs.Play()
        }
        else
        {
            // 需要讀取音檔，先將狀態改成讀取中
            // 等讀取完畢，再改成播放中   Tim22.01.18
            intAudioStatus = window.gAudioStatusEnum.Loading
            let strAudioUrl = window.Globals.GetResourceUrl(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFN)
            window.AudioLibs.PlayAudio(strAudioUrl)
        }

        if (mintPlayAudioIndex !== QuestionIndex)
        {
            arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        }

        arrAudioStatus[QuestionIndex] = intAudioStatus
        mintPlayAudioIndex = QuestionIndex
        setAudioStatusArray(arrAudioStatus)
    } // end of AudioPlayOnTapHandler

    /*===========================================
    summary: 點選 聲音停止
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioStopOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1

        window.AudioLibs.StopAudio()
    } // end of AudioStopOnTapHandler

    /*===========================================
    summary: 點選 聲音暫停
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function AudioPauseOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioPauseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Paused
        setAudioStatusArray(arrAudioStatus)     

        window.AudioLibs.PauseAudio()
    } // end of AudioPauseOnTapHandler

    /*===========================================
    summary: 點選 圖片 答案選項
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function AnswerImageOnTapHandler(QuestionIndex, ChoiceQIndex, AnswerIndex)
    {
        // console.log(COMP_NAME + ".AnswerImageOnTapHandler: ")    // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AnswerImageOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".AnswerImageOnTapHandler marrDisplayQuestion: ", marrDisplayQuestion)

        marrDisplayQuestion[QuestionIndex].ChoiceQ[ChoiceQIndex].CQAnswerPos = AnswerIndex + 1

        // 檢查 是否 全部題目都有作答
        let blnIsAllSelected = CheckIsAllAnswerSelected()

        if (blnIsAllSelected)
        {
            mobjTestSheetContext.Dirty = true

            // 通知 TestSheetContext Dirty 有改變
            let objCallbackData = {
                "Action": "TestSheetContextDirty"
            }
            props.CallbackRef(objCallbackData)
        }

        setUpdateDataTime(new Date().getTime())
    } // end of AnswerImageOnTapHandler

    /*===========================================
    summary: 點選 文字 答案選項
    remarks: 000 Tim 2022/01/06 Create
    ===========================================*/
    function AnswerTextOnTapHandler(QuestionIndex, ChoiceQIndex, AnswerIndex)
    {
        // console.log(COMP_NAME + ".AnswerTextOnTapHandler: ")    // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".AnswerTextOnTapHandler BEGIN")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        console.log(COMP_NAME + ".AnswerTextOnTapHandler marrDisplayQuestion: ", marrDisplayQuestion)

        marrDisplayQuestion[QuestionIndex].ChoiceQ[ChoiceQIndex].CQAnswerPos = AnswerIndex + 1

        // 檢查 是否 全部題目都有作答
        let blnIsAllSelected = CheckIsAllAnswerSelected()

        if (blnIsAllSelected)
        {
            mobjTestSheetContext.Dirty = true

            // 通知 TestSheetContext Dirty 有改變，通知父層 按鈕變化
            let objCallbackData = {
                "Action": "TestSheetContextDirty"
            }
            props.CallbackRef(objCallbackData)
        }

        setUpdateDataTime(new Date().getTime())
    } // end of AnswerTextOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        // console.log(COMP_NAME + ".PlayAudioEndHandler: ")    // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PlayAudioEndHandler BEGIN")

        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1
    } // end of PlayAudioEndHandler

    /*===========================================
    summary: 聲音檔 讀取完畢
    remarks: 000 Tim 2022/01/18 Create
    ===========================================*/
    function PlayAudioCanPlayHandler()
    {
        // console.log(COMP_NAME + ".PlayAudioCanPlayHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".PlayAudioCanPlayHandler BEGIN")
        
        // 音檔讀取完畢，將狀態改成播放中   Tim22.01.18
        setTimeout(function()
        {
            let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
            arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Playing
            setAudioStatusArray(arrAudioStatus)
        }, 500)
    } // end of PlayAudioCanPlayHandler

    /*===========================================
    summary: 語言設定 改變 事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function LanguageOnChangeHandler()
    {
        // console.log(COMP_NAME + ".LanguageOnChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".LanguageOnChangeHandler BEGIN")

        setUpdateDataTime(0)
        
        // 練習 讀一讀                LUSeqNo: 15
        if (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)
        {
            // 整理 標題資訊 (SubSubSection)
            mobjDisplaySubSubSection.NameEN = props.SubSectionDef.SubSubSection[0].Name
            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MajorName
            }
            else
            {
                mobjDisplaySubSubSection.NameCN = props.SubSectionDef.SubSubSection[0].MinorName
            }
        } // end of if (parseInt(props.LUInfo.LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)
        
        InitContentDataProcessBegin()
    } // end of LanguageOnChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        // console.log(COMP_NAME + ".CloseLoadingMask: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CloseLoadingMask BEGIN")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 改變 TestSheetMode
    remarks: 000 Tim 2022/01/06 Create
    ===========================================*/
    function ChangeTestSheetMode(TestSheetMode, Index4HistoryItemToShow)
    {
        console.log(COMP_NAME + ".ChangeTestSheetMode: TestSheetMode: ", TestSheetMode)

        // 通知 上一層 
        let objCallbackData = {
            "Action": "ChangeTestSheetMode",
            "TestSheetMode": TestSheetMode,
            "Index4HistoryItemToShow": Index4HistoryItemToShow
        }
        props.CallbackRef(objCallbackData)
    } // end of ChangeTestSheetMode
    // #endregion LoadingMask and Alert

    // #region Component Callback
    /*===========================================
    summary: 歷史紀錄視窗 Callback
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function HistoryWindowCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".HistoryWindowCallback: ", CallbackObj)

        let enumTestSheeMode = -1
        let intIndex4HistoryItemToShow = 0
        if (CallbackObj.Action === "HistoryWindowDetail")
        {
            console.log("HistoryWindowCallback.DetailOnTap")
            console.log("CallbackObj.AssignmentIndex:", CallbackObj.AssignmentIndex)

            intIndex4HistoryItemToShow = parseInt(CallbackObj.AssignmentIndex)
            enumTestSheeMode = TestSheetModeEnum.History
        }

        if (enumTestSheeMode !== -1)
        {
            ChangeTestSheetMode(enumTestSheeMode, intIndex4HistoryItemToShow)
        } // end of if (enumTestSheeMode !== -1)
    } // end of HistoryWindowCallback
    // #endregion Component Callback

    // #region Other Functions

    function RegisterAudioEvent()
    {
        console.log(COMP_NAME + ".RegisterAudioEvent")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioCanPlayHandler, window.AudioLibs.RegisterEventTypeEnum.AudioCanPlay)
        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
    }
    
    /*===========================================
    summary: 註冊 執行 ChoiceContent 動作
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RegisterExecuteChoiceContentAction ()
    {
        let objCallbackData = {
            "Action": "RegisterExecuteChoiceContentAction",
            "Function": ExecuteChoiceContentAction
        }

        props.CallbackRef(objCallbackData)
    } // end of RegisterExecuteChoiceContentAction

    /*===========================================
    summary: 註冊 語言改變事件
    remarks: 000 Tim 2022/01/14 Create
    ===========================================*/
    function RegisterLanguageChangeHandler()
    {
        // console.log(COMP_NAME + ".RegisterLanguageChangeHandler: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".RegisterLanguageChangeHandler BEGIN")
        
        let objCallbackData = {
            "Action": "RegisterLanguageChangeHandler",
            "Function": LanguageOnChangeHandler
        }
        props.CallbackRef(objCallbackData)
    } // end of RegisterLanguageChangeHandler

    /*===========================================
    summary: 執行 ChoiceContent 動作
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ExecuteChoiceContentAction (Action)
    {
        console.log(COMP_NAME + ".ExecuteChoiceContentAction Action: ", Action)

        if (Action !== ExecuteActionEnum.UpdateDisplay)
        {
            // 先停止播放，再執行動作
            window.AudioLibs.StopAudio()
            let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
            arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
            setAudioStatusArray(arrAudioStatus)
            mintPlayAudioIndex = -1
        }

        switch (Action) 
        {
            case ExecuteActionEnum.Retry:
                ExecuteRetry()
                break
            case ExecuteActionEnum.SubmitAnswer:
                ExecuteSubmitAnswer()
                break
            case ExecuteActionEnum.UpdateDisplay:
                ExecuteUpdateDisplay()
                break
            case ExecuteActionEnum.RegisterAudioEvent:
                console.log("ExecuteChoiceContentAction.RegisterAudioEvent: ")
                RegisterAudioEvent()
                break              
            default:
                break
        } // end of switch (Action)
    } // end of ExecuteChoiceContentAction

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadImage)

        marrContentData = []

        let arrKeywordList = []
        let objContent = null

        // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小，且顯示題目縮圖
        // Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示
        // Step 4. 讀取 答案原圖 每讀取完一張原圖 就顯示

        props.LUInfo.SuperQuestion.forEach((SuperQuestion) => {
            // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SuperQuestion.ContentHTML.MajorLangKeyword : SuperQuestion.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(SuperQuestion.ContentHTML.TextWithHeight, arrKeywordList, mstrImagePrefix)

            marrContentData.push(objContent)
        })

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        CloseLoadingMask()

        marrDisplayQuestion = FormatCQQuestionData(props.LUInfo, mobjTestSheetContext)

        console.log(COMP_NAME + ".InitContentDataProcessEnd marrDisplayQuestion: ", marrDisplayQuestion)

        InitAudioStatusArray(marrDisplayQuestion)

        // 先顯示出來
        setUpdateDataTime(new Date().getTime())

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd

    // #region PreloadImage
    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintSQIndex4PreloadThumbnailImage = 0
        mintImgIndex4PreloadThumbnailImage = 0

        if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
    } // end of PreloadThumbnailImageProcessBegin

    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        marrContentData.forEach((ContentData) => {
            // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)

            console.log("ContentData: ", ContentData)
        }) // end of forEach marrContentData

        console.log("PreloadThumbnailImageProcessEnd END marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    } // end of PreloadThumbnailImageProcessEnd

    /*===========================================
    summary: 讀取 縮圖 題目圖片
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function LoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(SQIndex, ImgIndex, this.width, this.height)
        }; // end of image onload
        // objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].Url
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].ThumbnailImageUrl
    } // end of LoadThumbnailImage

    /*===========================================
    summary: 讀取 縮圖 題目圖片完成 事件
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function ThumbnailImageLoadedHandler(SQIndex, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", SQIndex, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[SQIndex].ImageList[ImgIndex].Width = Width
            marrContentData[SQIndex].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[SQIndex].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler END DisplayHeight: ", parseInt(marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight))

            GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler ContentData null")
        }
    } // end of ThumbnailImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 縮圖
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadThumbnailImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadThumbnailImage++
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadThumbnailImage++
            mintImgIndex4PreloadThumbnailImage = 0

            if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
            else
            {
                GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    } // end of GotoNextLoadThumbnailImage

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")

        mintSQIndex4PreloadOriginalImage = 0
        mintImgIndex4PreloadOriginalImage = 0

        if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
    } // end of PreloadOriginalImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")

        // Step 4. 讀取 答案原圖 每讀取完一張原圖 就顯示
        PreloadOriginalAnswerImageProcessBegin()
    } // end of PreloadOriginalImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 題目圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(SQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalImage

    /*===========================================
    summary: 讀取 原圖 題目圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalImageLoadedHandler(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", SQIndex, ImgIndex)
        
        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[SQIndex].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[SQIndex].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)
            marrDisplayQuestion[SQIndex].ContentText = marrContentData[SQIndex].ContentText
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalImageLoadedHandler ContentData null")
        }
    } // end of OriginalImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadOriginalImage++
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadOriginalImage++
            mintImgIndex4PreloadOriginalImage = 0

            if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
            else
            {
                GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalImage

    /*===========================================
    summary: 預讀 原圖 答案圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalAnswerImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalAnswerImageProcessBegin: ")

        mintSQIndex4OriginalAnsImg = 0
        mintCQIndex4OriginalAnsImg = 0
        mintImgIndex4OriginalAnsImg = 0
        
        if (
            (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].AnswerType) === AnswerTypeEnum.Image) &&
            (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].Answer.length > 0)
            )
        {
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else
        {
            GotoNextLoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
    } // end of PreloadOriginalAnswerImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 答案圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalAnswerImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalAnswerImageProcessEnd: ")
    } // end of PreloadOriginalAnswerImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 答案圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalAnswerImage: ", SQIndex, CQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalAnswerImageLoadedHandler(SQIndex, CQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalAnswerImage

    /*===========================================
    summary: 讀取 原圖 答案圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalAnswerImageLoadedHandler(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalAnswerImageLoadedHandler: ", SQIndex, CQIndex, ImgIndex)
        
        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrDisplayQuestion.length > 0) &&
            (typeof(marrDisplayQuestion[SQIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex] !== null) &&
            (typeof(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex] !== null) &&
            (typeof(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex] !== null)
            )
        {
            marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].DisplayUrl = marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].OriginalImageUrl
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalAnswerImageLoadedHandler ContentData null")
        }
    } // end of OriginalAnswerImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 答案原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage: ", SQIndex, CQIndex, ImgIndex)

        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage DQ: ", marrDisplayQuestion[SQIndex])
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage ChoiceQ.length: ", marrDisplayQuestion[SQIndex].ChoiceQ.length)
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage Answer.length: ", marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer.length)

        if (
            (marrDisplayQuestion[SQIndex].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
            (ImgIndex < (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4OriginalAnsImg++
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else if (
            (marrDisplayQuestion[SQIndex].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
            (CQIndex < (marrDisplayQuestion[SQIndex].ChoiceQ.length - 1))
            )
        {
            mintCQIndex4OriginalAnsImg++
            mintImgIndex4OriginalAnsImg = 0
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else if (SQIndex < (marrDisplayQuestion.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4OriginalAnsImg++
            mintCQIndex4OriginalAnsImg = 0
            mintImgIndex4OriginalAnsImg = 0

            if (
                (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ.length > 0) &&
                (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
                (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].Answer.length > 0)
                )
            {
                LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
            }
            else
            {
                GotoNextLoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
            }
        }
        else
        {
            PreloadOriginalAnswerImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalAnswerImage
    // #endregion PreloadImage

    /*===========================================
    summary: 初始化 選擇題 顯示資料
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function FormatCQQuestionData(LUInfo, TestSheet)
    {
        console.log(COMP_NAME + ".FormatCQQuestionData: ", LUInfo, TestSheet)

        let arrSuperQuestion = LUInfo.SuperQuestion
        let arrDisplayQuestion = []
        let objDisplayQuestion = null
        let objChoiceQ = null

        let intSQIndex = 0
        let intSQCount = arrSuperQuestion.length
        let intCQIndex = 0
        let intCQCount = 0
        let arrAnswer = TestSheet.AnswerList
        let objAnswer = null
        let intAIndex = 0
        let intACount = 0

        let arrChoiceQ = []
        let arrCAnswer = []
        let objCAnswer = null

        let intDefQShow = 0
        let intDefAShow = 0

        let strOriginalImageUrl = ""
        let strThumbnailImageUrl = ""

        let objContent = null
        console.log(COMP_NAME + ".FormatCQQuestionData marrContentData: ", marrContentData)

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            // 處理 顯示的 Content
            objContent = marrContentData[intSQIndex]
            console.log(COMP_NAME + ".FormatCQQuestionData objContent: ", objContent)

            objDisplayQuestion = {
                "SQSeqNo": arrSuperQuestion[intSQIndex].SQSeqNo,
                "ContentText": objContent.ContentText,
                "AudioFN": objContent.AudioFN,
                "IsAudio": objContent.IsAudio,
                "AnswerType": -1,
                "ChoiceQ": []
            }

            intCQIndex = 0
            intCQCount = arrSuperQuestion[intSQIndex].ChoiceQ.length
            arrChoiceQ = arrSuperQuestion[intSQIndex].ChoiceQ

            if (intCQCount > 0)
            {
                objDisplayQuestion.AnswerType = arrChoiceQ[0].AnswerType
            }

            for (intCQIndex = 0; intCQIndex < intCQCount; intCQIndex++)
            {
                objChoiceQ = {
                    "CQSeqNo": arrChoiceQ[intCQIndex].CQSeqNo,
                    "QuestionText": "",
                    "AnswerType": arrChoiceQ[intCQIndex].AnswerType,
                    "AnswerPos": arrChoiceQ[intCQIndex].AnswerPos,
                    "Answer": [],
                    "CQAnswerPos": -1
                }

                let intSQSeqNo = parseInt(arrSuperQuestion[intSQIndex].SQSeqNo)
                let intCQSeqNo = parseInt(arrChoiceQ[intCQIndex].CQSeqNo)
                intDefQShow = arrChoiceQ[intCQIndex].DefQShow
                intDefAShow = arrChoiceQ[intCQIndex].DefAShow

                // 有 DefQShowNew 使用這個值 沒有的話，沿用 DefQShow，舊程式沒註解，不知道原因     Tim16.11.28
                if (
                    (typeof(arrChoiceQ[intCQIndex].DefQShowNew) !== 'undefined') &&
                    (arrChoiceQ[intCQIndex].DefQShowNew !== null) &&
                    (arrChoiceQ[intCQIndex].DefQShowNew !== '') &&
                    (!isNaN(parseInt(arrChoiceQ[intCQIndex].DefQShowNew)))
                    )
                {
                    intDefQShow = parseInt(arrChoiceQ[intCQIndex].DefQShowNew)
                }

                // 找出 顯示 題目文字
                if (parseInt(intDefQShow) === 1)
                {
                    objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].Q
                }
                else
                {
                    if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                    {
                        objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].MajorQ
                    }
                    else
                    {
                        objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].MinorQ
                    }
                }

                // 找出 使用者 選擇的答案
                objAnswer = arrAnswer.find(AnswerData => 
                    (
                        (parseInt(AnswerData.SQSeqNo) === intSQSeqNo) &&
                        (parseInt(AnswerData.CQSeqNo) === intCQSeqNo)
                    )
                )
                
                if (
                    (typeof(objAnswer) !== 'undefined') &&
                    (objAnswer !== null) &&
                    (typeof(objAnswer.CQAnswerPos) !== 'undefined') &&
                    (objAnswer.CQAnswerPos !== null) &&
                    (objAnswer.CQAnswerPos !== '') &&
                    (parseInt(objAnswer.CQAnswerPos) > 0)
                    )
                {
                    objChoiceQ.CQAnswerPos = parseInt(objAnswer.CQAnswerPos)
                } // end of if (objAnswer !== null)
                
                // 塞入 選擇題 答案陣列
                intAIndex = 0
                intACount = arrChoiceQ[intCQIndex].Answer.length
                arrCAnswer = []
                for (intAIndex = 0; intAIndex < intACount; intAIndex++)
                {
                    if (parseInt(objChoiceQ.AnswerType) === AnswerTypeEnum.Text)
                    {
                        objCAnswer = {
                            "AnswerText": ""
                        }
                        // 找出 顯示 答案文字
                        if (parseInt(intDefAShow) === 1)
                        {
                            objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].A
                        }
                        else if (parseInt(intDefAShow) === 2)
                        {
                            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                            {
                                objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].MajorA
                            }
                            else
                            {
                                objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].MinorA
                            }
                        }
                    }
                    else
                    {
                        strOriginalImageUrl = mstrImagePrefix + arrChoiceQ[intCQIndex].Answer[intAIndex].ImgAFN
                        strThumbnailImageUrl = window.Globals.GetImageThumbnailUrl(strOriginalImageUrl)
                        
                        objCAnswer = {
                            "ImgAFN": arrChoiceQ[intCQIndex].Answer[intAIndex].ImgAFN,
                            "DisplayUrl": strThumbnailImageUrl,
                            "OriginalImageUrl": strOriginalImageUrl,
                            "ThumbnailImageUrl": strThumbnailImageUrl
                        }
                    }
                    arrCAnswer.push(objCAnswer)
                } // end of for (intAIndex = 0;
                objChoiceQ.Answer = arrCAnswer

                objDisplayQuestion.ChoiceQ.push(objChoiceQ)
            } // end of for (intFQIndex = 0;
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSQIndex = 0;

        console.log(COMP_NAME + ".FormatCQQuestionData END arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatCQQuestionData

    /*===========================================
    summary: 初始化 音檔狀態
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function InitAudioStatusArray(DisplayQuestion)
    {
        let arrAudioStatus = []
        DisplayQuestion.forEach(() => {
            arrAudioStatus.push(window.gAudioStatusEnum.Stop)
        })

        console.log(COMP_NAME + ".InitAudioStatusArray arrAudioStatus: ", arrAudioStatus)

        setAudioStatusArray(arrAudioStatus)
    } // end of InitAudioStatusArray

    /*===========================================
    summary: 執行儲存答案
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function CheckIsAllAnswerSelected()
    {
        // console.log(COMP_NAME + ".CheckIsAllAnswerSelected: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CheckIsAllAnswerSelected BEGIN")
        
        let intSQIndex = 0
        let intSQCount = marrDisplayQuestion.length
        let intCQIndex = 0
        let intCQCount = 0
        let blnIsAllSelected = true

        while (blnIsAllSelected && (intSQIndex < intSQCount))
        {
            intCQIndex = 0
            intCQCount = marrDisplayQuestion[intSQIndex].ChoiceQ.length

            while (blnIsAllSelected && (intCQIndex < intCQCount))
            {
                if (
                    (marrDisplayQuestion[intSQIndex].ChoiceQ[intCQIndex].CQAnswerPos === null) ||
                    (parseInt(marrDisplayQuestion[intSQIndex].ChoiceQ[intCQIndex].CQAnswerPos) === -1)
                    )
                {
                    blnIsAllSelected = false
                }
                intCQIndex++
            } // end of while (intCQIndex

            intSQIndex++
        } // end of while (intSQIndex

        console.log(COMP_NAME + ".CheckIsAllAnswerSelected END blnIsAllSelected: ", blnIsAllSelected)
        
        return blnIsAllSelected
    } // end of CheckIsAllAnswerSelected

    /*===========================================
    summary: 執行儲存答案
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ExecuteRetry()
    {
        console.log(COMP_NAME + ".ExecuteRetry: mobjTestSheetContext: ", mobjTestSheetContext)

        marrDisplayQuestion = FormatCQQuestionData(props.LUInfo, mobjTestSheetContext)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".ExecuteRetry marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of ExecuteRetry

    /*===========================================
    summary: 執行儲存答案
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ExecuteSubmitAnswer()
    {
        console.log(COMP_NAME + ".ExecuteSubmitAnswer: mobjTestSheetContext: ", mobjTestSheetContext)

        // 將 DisplayQuestion 改的答案，同步到 TestSheetContext
        let intSQIndex = 0
        let intSQCount = marrDisplayQuestion.length
        let intCQIndex = 0
        let intCQCount = 0
        let objAnswer = null

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            intCQCount = marrDisplayQuestion[intSQIndex].ChoiceQ.length

            for (intCQIndex = 0; intCQIndex < intCQCount; intCQIndex++)
            {
                let intSQSeqNo = parseInt(marrDisplayQuestion[intSQIndex].SQSeqNo)
                let intCQSeqNo = parseInt(marrDisplayQuestion[intSQIndex].ChoiceQ[intCQIndex].CQSeqNo)

                objAnswer = mobjTestSheetContext.AnswerList.find(AnswerData => 
                    (
                        (parseInt(AnswerData.SQSeqNo) === intSQSeqNo) &&
                        (parseInt(AnswerData.CQSeqNo) === intCQSeqNo)
                    )
                )

                objAnswer.CQAnswerPos = marrDisplayQuestion[intSQIndex].ChoiceQ[intCQIndex].CQAnswerPos
            } // end of for (intCQIndex = 0;
        } // end of for (intSQIndex = 0;
        
        console.log(COMP_NAME + ".ExecuteSubmitAnswer END mobjTestSheetContext: ", mobjTestSheetContext)

        mobjCallParam = {
            "BookCategoryID": mstrBookCatID,
            "LessonID": props.LessonID,
            "ClassID": mintClassID,
            "LUCatSeqNo": props.LUInfo.LUCatSeqNo,
            "AnswerList": mobjTestSheetContext.AnswerList
        }
        UploadNewAssignmentResult()
    } // end of ExecuteSubmitAnswer

    /*===========================================
    summary: 執行更新 顯示資料
    remarks: 000 Tim 2022/01/06 Create
    ===========================================*/
    function ExecuteUpdateDisplay()
    {
        console.log(COMP_NAME + ".ExecuteUpdateDisplay: mobjTestSheetContext: ", mobjTestSheetContext)

        marrDisplayQuestion = FormatCQQuestionData(props.LUInfo, mobjTestSheetContext)
        setUpdateDataTime(new Date().getTime())
        console.log(COMP_NAME + ".ExecuteUpdateDisplay marrDisplayQuestion: ", marrDisplayQuestion)
    } // end of ExecuteUpdateDisplay

    /*===========================================
    summary: Submit後 更新 Cache資料
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function UpdateCacheSinceSubmit(DataFromSubmit)
    {
        console.log(COMP_NAME + ".UpdateCacheSinceSubmit: ", DataFromSubmit)

        let objTestTime = new Date()

        let objNewAssign = {
            "AnswerList": DataFromSubmit.AnswerList,
            "AssignID": DataFromSubmit.AssignID,
            "Score": DataFromSubmit.Score,
            "TestedTime": objTestTime.ToBCUTCString()
        }

        // 更新 History 資料
        console.log("objNewAssign: ", objNewAssign)
        mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext].NewAssignList.unshift(objNewAssign)

        setUpdateDataTime(new Date().getTime())
    } // end of UpdateCacheSinceSubmit
    // #endregion Other Functions

    // #region Get ClassName and Style
    /*===========================================
    summary: 取得 QuestionArea Cls
    remarks: 000 Tim 2022/01/06 Create
    ===========================================*/
    function GetQuestionAreaCls(LUCatSeqNo)
    {
        let objCls = cssChoiceContent.divQuestionArea

        if (parseInt(LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)
        {
            objCls = cssChoiceContent.divQuestionArea4ReadingComprehension
        }

        return objCls
    } // end of GetQuestionAreaCls

    /*===========================================
    summary: 取得 送出作答資料按鈕 Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetSubmitButtonCls(TestSheet)
    {
        let objCls = cssChoiceContent.btnScoreToolMainDisable

        if (TestSheet.Dirty)
        {
            objCls = cssChoiceContent.btnScoreToolMain
        }

        return objCls
    } // end of GetSubmitButtonCls

    /*===========================================
    summary: 取得 歷史紀錄按鈕 Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetHistoryButtonMainCls(HistoryData)
    {
        let objCls = cssChoiceContent.btnScoreToolMainDisable
         // 有 答題完成的歷史答案
        if (
            (typeof (HistoryData) !== "undefined") &&
            (HistoryData !== null) &&
            (typeof (HistoryData.NewAssignList) !== "undefined") &&
            (HistoryData.NewAssignList !== null) &&
            (HistoryData.NewAssignList.length > 0)
            )
        {
            objCls = cssChoiceContent.btnScoreToolMain
        }
        return objCls
    } // end of GetHistoryButtonMainCls

    /*===========================================
    summary: 取得 再做一次 按鈕 Cls
    remarks: 000 Tim 2022/03/11 Create
    ===========================================*/
    function GetRetryButtonCls(PropsIsBlockedInstructor)
    {
        let objCls = cssChoiceContent.btnScoreToolMain

        if (PropsIsBlockedInstructor)
        {
            objCls = cssChoiceContent.btnScoreToolMainDisable
        }

        return objCls
    } // end of GetRetryButtonCls

    /*===========================================
    summary: 取得 題目 元件 Cls
    remarks: 000 Tim 2022/01/06 Create
    ===========================================*/
    function GetQuestionUnitCls(AnswerType)
    {
        let objCls = cssChoiceContent.divQuestionImageUnitMain
        if (parseInt(AnswerType) === AnswerTypeEnum.Text)
        {
            objCls = cssChoiceContent.divQuestionTextUnitMain
        }

        return objCls
    } // end of GetQuestionUnitCls

    /*===========================================
    summary: 取得 答案選項 圖片外框 Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetAnswerImageCls(AnswerIndex, AnswerPos, CQAnswerPos, TestSheetMode, PropsIsBlockedInstructor)
    {
        let objCls = null

        
        if (TestSheetMode === TestSheetModeEnum.New)
        {
            if (PropsIsBlockedInstructor)
            {
                objCls = cssChoiceContent.divAnswerImageDisabled
            }
            else
            {
                objCls = cssChoiceContent.btnAnswerImage

                if (CQAnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divAnswerImageSelected
                }
            }
        }
        else
        {
            objCls = cssChoiceContent.divAnswerImage

            if (CQAnswerPos === (AnswerIndex + 1))
            {
                if (AnswerPos === CQAnswerPos)
                {
                    objCls = cssChoiceContent.divAnswerImageSuccess
                }
                else
                {
                    objCls = cssChoiceContent.divAnswerImageWrong
                }
            }

            if (
                (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                (window.gSession.Acc.CurrentClassIndex !== null) &&
                (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                (window.gSession.Acc.Class !== null) &&
                (window.gSession.Acc.Class.length !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            {
                // 老師設定 不顯示正確答案
            }
            else
            {
                // 其他都要顯示正確答案
                if (AnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divAnswerImageSuccess
                }
            }
        }

        return objCls
    } // end of GetAnswerImageCls

    /*===========================================
    summary: 取得 圖片題 答案選項 Icon Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetAnswerImageIconCls(AnswerIndex, AnswerPos
        , CQAnswerPos, TestSheetMode)
    {
        let objCls = cssChoiceContent.divAnswerImageIcon

        if (TestSheetMode !== TestSheetModeEnum.New)
        {
            if (CQAnswerPos === (AnswerIndex + 1))
            {
                if (AnswerPos === CQAnswerPos)
                {
                    objCls = cssChoiceContent.divAnswerImageIconSuccess
                }
                else
                {
                    objCls = cssChoiceContent.divAnswerImageIconWrong
                }
            }

            if (
                (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                (window.gSession.Acc.CurrentClassIndex !== null) &&
                (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                (window.gSession.Acc.Class !== null) &&
                (window.gSession.Acc.Class.length !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            {
                // 老師設定 不顯示正確答案
            }
            else
            {
                // 其他都要顯示正確答案
                if (AnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divAnswerImageIconSuccess
                }
            }
        }

        return objCls
    } // end of GetAnswerImageIconCls

    /*===========================================
    summary: 取得 文字題 答案選項 圖片外框 Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetTextAnswerTextAreaCls(AnswerIndex, AnswerPos, CQAnswerPos, TestSheetMode, PropsIsBlockedInstructor)
    {
        let objCls = cssChoiceContent.btnTextAnswerTextArea

        if (TestSheetMode === TestSheetModeEnum.New)
        {
            if (PropsIsBlockedInstructor)
            {
                objCls = cssChoiceContent.divTextAnswerTextAreaDisabled
            }
            else
            {
                objCls = cssChoiceContent.btnTextAnswerTextArea

                if (CQAnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divTextAnswerTextAreaSelected
                }
            }
        }
        else
        {
            objCls = cssChoiceContent.divTextAnswerTextArea

            if (CQAnswerPos === (AnswerIndex + 1))
            {
                if (AnswerPos === CQAnswerPos)
                {
                    objCls = cssChoiceContent.divTextAnswerTextAreaSuccess
                }
                else
                {
                    objCls = cssChoiceContent.divTextAnswerTextAreaWrong
                }
            }

            if (
                (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                (window.gSession.Acc.CurrentClassIndex !== null) &&
                (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                (window.gSession.Acc.Class !== null) &&
                (window.gSession.Acc.Class.length !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            {
                // 老師設定 不顯示正確答案
            }
            else
            {
                // 其他都要顯示正確答案
                if (AnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divTextAnswerTextAreaSuccess
                }
            }
        }

        return objCls
    } // end of GetTextAnswerTextAreaCls

    /*===========================================
    summary: 取得 文字題 答案選項 Icon Cls
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function GetAnswerTextIconCls(AnswerIndex, AnswerPos, CQAnswerPos, TestSheetMode)
    {
        let objCls = cssChoiceContent.divAnswerTextIcon

        if (TestSheetMode !== TestSheetModeEnum.New)
        {
            if (CQAnswerPos === (AnswerIndex + 1))
            {
                if (AnswerPos === CQAnswerPos)
                {
                    objCls = cssChoiceContent.divAnswerTextIconSuccess
                }
                else
                {
                    objCls = cssChoiceContent.divAnswerTextIconWrong
                }
            }

            if (
                (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                (window.gSession.Acc.CurrentClassIndex !== null) &&
                (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                (window.gSession.Acc.Class !== null) &&
                (window.gSession.Acc.Class.length !== null) &&

                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                
                (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            {
                // 老師設定 不顯示正確答案
            }
            else
            {
                // 其他都要顯示正確答案
                if (AnswerPos === (AnswerIndex + 1))
                {
                    objCls = cssChoiceContent.divAnswerTextIconSuccess
                }
            }
        }

        return objCls
    } // end of GetAnswerTextIconCls
    // #endregion Get ClassName and Style

    // #region Web Service After Process
    /*===========================================
    summary: 上傳 考卷答案 資料 後續處理
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function UploadNewAssignmentResultAfterProcess(ReturnData)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultAfterProcess: ", ReturnData)

        UpdateCacheSinceSubmit(ReturnData)
        
        mobjCallParam = null

        let intIndex4HistoryItemToShow = 0
        ChangeTestSheetMode(TestSheetModeEnum.History, intIndex4HistoryItemToShow)
    } // end of UploadNewAssignmentResultAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 上傳 考卷答案 資料
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function UploadNewAssignmentResult()
    {
        // console.log(COMP_NAME + ".UploadNewAssignmentResult: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".UploadNewAssignmentResult BEGIN")
        let objRetryFuncRef = UploadNewAssignmentResult
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_UploadAssignmentResult_Title, window.gAppUI.ERR_UploadAssignmentResult_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UploadNewAssignmentResultCallback

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UploadNewAssignmentResult)

            let objCallData = {
                "Func": "UploadNewAssignmentResult",
                "BookCategoryID": mobjCallParam.BookCategoryID,
                "LessonID": mobjCallParam.LessonID,
                "ClassID": mobjCallParam.ClassID,
                "LUCatSeqNo": mobjCallParam.LUCatSeqNo,
                "Answer": JSON.stringify(mobjCallParam.AnswerList)
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UploadNewAssignmentResult

    /*===========================================
    summary: 上傳 考卷答案 資料 Callback
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function UploadNewAssignmentResultCallback(Return)
    {
        console.log(COMP_NAME + ".UploadNewAssignmentResultCallback: ", Return)
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UploadAssignmentTmpResult_No
        let strErrorTitle = window.gAppUI.ERR_UploadAssignmentResult_Title
        let strErrMsg = window.gAppUI.ERR_UploadAssignmentResult_Msg

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UploadNewAssignmentResultCallback: ErrNo: ", Return.ErrNo)
            console.log("UploadNewAssignmentResultCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UploadNewAssignmentResultCallback Return.Data", Return.Data)

            UploadNewAssignmentResultAfterProcess(Return.Data)
        }
    } // end of UploadNewAssignmentResultCallback
    // #endregion Web Service

    // #region Component            
    /*===========================================
    summary: Submit or Start 按鈕 顯示Component  
    remarks: 000 Tim 2022/01/05 Create
             001 Tim 2022/03/11 補上 BlockedInstructor 機制
    ===========================================*/
    function ComponentSubmitOrStartButton( {TestSheet, PropsIsBlockedInstructor} )
    {  
        let objButtonBlock = null
        if (TestSheet.Mode === TestSheetModeEnum.History)
        {
            // Start
            objButtonBlock =    <div className={GetRetryButtonCls(PropsIsBlockedInstructor)} onClick={() => TryAgainOnTapHandler()}>
                                    <div className={cssChoiceContent.divTryAgainIcon}/>
                                    <div className={cssChoiceContent.divScoreToolButtonText}>
                                        {PackageVariablesLibs.UISettings.BTN_Retry}
                                    </div>
                                </div>
        }
        else if (TestSheet.Mode === TestSheetModeEnum.New)
        {
            objButtonBlock =    <div className={GetSubmitButtonCls(TestSheet)} onClick={() => SubmitOnTapHandler()}>
                                    <div className={cssChoiceContent.divSubmitIcon}/>
                                    <div className={cssChoiceContent.divScoreToolButtonText}>
                                        {window.gAppUI.BTN_Submit}
                                    </div>
                                </div>
        }

        return(
            <>
                <div className={cssChoiceContent.divScoreToolBar}/>

                {objButtonBlock}
            </>
        )
    } // end of ComponentSubmitOrStartButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ComponentHistoryButton( {HistoryData} )
    {  
        return(
            <>
                <div className={cssChoiceContent.divScoreToolBar}/>
                
                <div className={GetHistoryButtonMainCls(HistoryData)} 
                        onClick={() => HistoryOnTapHandler()}>
                    <div className={cssChoiceContent.divHistoryIcon}/>
                    <div className={cssChoiceContent.divScoreToolButtonText}>
                        {window.gAppUI.BTN_History}
                    </div>
                </div>
            </>
        )
    } // end of ComponentHistoryButton

    /*===========================================
    summary: 分數 區域 顯示Component  
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ComponentScoreArea( {TestSheetScore} )
    {  
        let strScore = window.gAppUI.LBL_NotScore
        if (
            (typeof(TestSheetScore) !== 'undefined') &&
            (TestSheetScore !== null) &&
            (parseInt(TestSheetScore) >= 0)
            )
        {
            strScore = TestSheetScore
        }

        return(
            <>
                <div className={cssChoiceContent.divScoreToolTitle}>
                    {window.gAppUI.LBL_YourScore}:
                </div>
                <div className={cssChoiceContent.divScoreToolScore}>
                    {strScore}
                </div>
            </>
        )
    } // end of ComponentScoreArea
    
    /*===========================================
    summary: ChoiceQNo 顯示Component  
    remarks: 000 Tim 2022/01/05 Create
             001 Tim 2022/08/25 改圖片 直接用 DisplayUrl顯示
    ===========================================*/
    function ComponentAnswerImage( {TestSheetMode, QuestionIndex
        , ChoiceQIndex, AnswerData, AnswerIndex
        , AnswerPos, CQAnswerPos, PropsIsBlockedInstructor} )
    {   
        // let strAnswerUrl = mstrImagePrefix + AnswerData.ImgAFN
        let objStyle = {
            backgroundImage: 'url(' + AnswerData.DisplayUrl + ')'
        }

        return(
            <div className={GetAnswerImageCls(AnswerIndex, AnswerPos, CQAnswerPos, TestSheetMode, PropsIsBlockedInstructor)} 
                style={objStyle}
                onClick={() => AnswerImageOnTapHandler(QuestionIndex, ChoiceQIndex, AnswerIndex)}/>
        )
    } // end of ComponentAnswerImage
    
    /*===========================================
    summary: ChoiceQNo 顯示Component
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ComponentAnswerNo( {AnswerIndex} )
    {   
        // AnsNo
        let strAnsNo = ""
        switch (AnswerIndex)
        {
            case 0:
                strAnsNo = 'a.';
                break
            case 1:
                strAnsNo = 'b.';
                break
            case 2:
                strAnsNo = 'c.';
                break
            case 3:
                strAnsNo = 'd.';
                break
            default:
                break
        } 

        return(
            <div className={cssChoiceContent.divAnswerNo}>
                {strAnsNo}
            </div>
        )
    } // end of ComponentAnswerNo

    /*===========================================
    summary: ChoiceQNo 顯示Component  
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function ComponentChoiceQNo( {ChoiceQIndex} )
    {   
        let strNo = (ChoiceQIndex + 1).toString() + "."
        return(
            <div className={cssChoiceContent.divChoiceQNo}>
                {strNo}
            </div>
        )
    } // end of ComponentChoiceQNo
    // #endregion Component

    // #region Render
    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderImageAnswerUnitWrapper(QuestionIndex, ChoiceQIndex
        , AnswerData, AnswerIndex, AnswerPos, CQAnswerPos)
    {
        return (
            <div className={cssChoiceContent.divImageAnswerUnitMain}>
                <ComponentAnswerNo AnswerIndex={AnswerIndex}/>

                <ComponentAnswerImage TestSheetMode={mobjTestSheetContext.Mode}
                    QuestionIndex={QuestionIndex} ChoiceQIndex={ChoiceQIndex}
                    AnswerData={AnswerData} AnswerIndex={AnswerIndex} 
                    AnswerPos={AnswerPos} CQAnswerPos={CQAnswerPos}
                    PropsIsBlockedInstructor={props.IsBlockedInstructor}/>

                <div className={GetAnswerImageIconCls(AnswerIndex, AnswerPos, CQAnswerPos, mobjTestSheetContext.Mode)}/>
            </div>
        )
    } // end of RenderImageAnswerUnitWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionAnswerImageWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
    {
        return (
            <div className={cssChoiceContent.divImageAnswerMain}>
                {ChoiceQData.Answer.map((AnswerData, AnswerIndex) =>
                    <div key={AnswerIndex} className={cssChoiceContent.divImageAnswerUnit}>
                        {RenderImageAnswerUnitWrapper(QuestionIndex
                            , ChoiceQIndex, AnswerData, AnswerIndex
                            , parseInt(ChoiceQData.AnswerPos)
                            , parseInt(ChoiceQData.CQAnswerPos))}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAnswerImageWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderTextAnswerUnitWrapper(QuestionIndex, ChoiceQIndex, AnswerData, AnswerIndex, AnswerPos, CQAnswerPos)
    {
        return (
            <div className={cssChoiceContent.divTextAnswerUnitMain}>
                <div className={GetTextAnswerTextAreaCls(AnswerIndex, AnswerPos, CQAnswerPos, mobjTestSheetContext.Mode, props.IsBlockedInstructor)}
                        onClick={() => AnswerTextOnTapHandler(QuestionIndex, ChoiceQIndex, AnswerIndex)}>
                    <ComponentAnswerNo AnswerIndex={AnswerIndex}/>
                    <div className={cssChoiceContent.divAnswerText}>
                        {AnswerData.AnswerText}
                    </div>
                </div>
                
                <div className={GetAnswerTextIconCls(AnswerIndex, AnswerPos, CQAnswerPos, mobjTestSheetContext.Mode)}/>
            </div>
        )
    } // end of RenderTextAnswerUnitWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionAnswerTextWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
    {
        return (
            <div className={cssChoiceContent.divTextAnswerMain}>
                {ChoiceQData.Answer.map((AnswerData, AnswerIndex) =>
                    <div key={AnswerIndex} className={cssChoiceContent.divTextAnswerUnit}>
                        {RenderTextAnswerUnitWrapper(QuestionIndex, ChoiceQIndex, AnswerData, AnswerIndex, parseInt(ChoiceQData.AnswerPos), parseInt(ChoiceQData.CQAnswerPos))}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAnswerTextWrapper

    /*===========================================
    summary: Render Question Sub Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionSubUnitWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
    {
        if (parseInt(ChoiceQData.AnswerType) === AnswerTypeEnum.Text)
        {
            return RenderQuestionAnswerTextWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
        }
        else
        {
            return RenderQuestionAnswerImageWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
        }
    } // end of RenderQuestionSubUnitWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)
    {
        return (
            <>
                <div className={cssChoiceContent.divQuestionTextMain}>
                    <ComponentChoiceQNo ChoiceQIndex={ChoiceQIndex}/>

                    <div className={cssChoiceContent.divQuestionText}>
                        {ChoiceQData.QuestionText}
                    </div>
                </div>

                {RenderQuestionSubUnitWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)}
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Question Audio Tool 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionAudioToolWrapper(QuestionData, QuestionIndex, StateAudioStatus)
    {
        if (
            (typeof (QuestionData.AudioFN) !== 'undefined') &&
            (QuestionData.AudioFN !== null) &&
            (QuestionData.AudioFN !== "")
            )
        {
            let objBlock = ""
            if (StateAudioStatus === window.gAudioStatusEnum.Loading)
            {
                // window.gAudioStatusEnum.Loading
                objBlock =  <>
                                <div className={cssChoiceContent.btnAudioLoading}/>
                                <div className={cssChoiceContent.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, audioStatusArray)}/>
                            </>
            }
            else if (StateAudioStatus === window.gAudioStatusEnum.Stop)
            {
                // window.gAudioStatusEnum.Stop
                objBlock =  <>
                                <div className={cssChoiceContent.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex, audioStatusArray)}/>
                                <div className={cssChoiceContent.btnAudioStopDisabled}/>
                            </>
            }
            else if (StateAudioStatus === window.gAudioStatusEnum.Playing)
            {
                // window.gAudioStatusEnum.Playing
                objBlock =  <>
                                <div className={cssChoiceContent.btnAudioPause} onClick={() => AudioPauseOnTapHandler(QuestionIndex, audioStatusArray)}/>
                                <div className={cssChoiceContent.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, audioStatusArray)}/>
                            </>
            }
            else
            {
                // window.gAudioStatusEnum.Paused
                objBlock =  <>
                                <div className={cssChoiceContent.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex, audioStatusArray)}/>
                                <div className={cssChoiceContent.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, audioStatusArray)}/>
                            </>
            }

            return (
                <div className={cssChoiceContent.divQuestionAudioTool}>
                    {objBlock}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderQuestionAudioToolWrapper

    /*===========================================
    summary: Render Question Title Area 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssChoiceContent.divQuestionTitleArea}>
                <div className={cssChoiceContent.divContentText}>
                    {parse(QuestionData.ContentText)}
                </div>

                {RenderQuestionAudioToolWrapper(QuestionData, QuestionIndex, audioStatusArray[QuestionIndex])}
            </div>
        )
    } // end of RenderQuestionTitleAreaWrapper

    /*===========================================
    summary: Render QuestionArea 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderQuestionAreaWrapper(LUCatSeqNo)
    {
        return (
            <div className={GetQuestionAreaCls(LUCatSeqNo)}>
                {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                    <div key={QuestionIndex} className={GetQuestionUnitCls(QuestionData.AnswerType)}>
                        {RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)}

                        {QuestionData.ChoiceQ.map((ChoiceQData, ChoiceQIndex) =>
                            <div key={ChoiceQIndex}  className={cssChoiceContent.divQuestionUnitArea}>
                                {RenderQuestionUnitWrapper(QuestionIndex, ChoiceQData, ChoiceQIndex)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAreaWrapper

    /*===========================================
    summary: Render ScoreToolArea 的顯示
    remarks: 000 Tim 2022/01/05 Create
             001 Tim 2022/03/11 補上 BlockedInstructor 機制
    ===========================================*/
    function RenderScoreToolAreaWrapper()
    {
        return (
            <div className={cssChoiceContent.divScoreToolArea}>
                <ComponentScoreArea TestSheetScore={mobjTestSheetContext.Score} />

                <ComponentHistoryButton HistoryData={mobjLUCacheContext.AssigementHistoryList[mstrLUKey4LUCachedContext]} />

                <ComponentSubmitOrStartButton TestSheet={mobjTestSheetContext} PropsIsBlockedInstructor={props.IsBlockedInstructor} />
            </div>
        )
    } // end of RenderScoreToolAreaWrapper

    /*===========================================
    summary: Render SubSub 標題區域 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderSubSubTitleAreaWrapper()
    {
        return (
            <div className={cssChoiceContent.divSubSubTitleArea}>
                <div className={cssChoiceContent.divSubSubTitleSubTopArea}>
                    <div className={cssChoiceContent.divSubSubTitle}>
                        {mobjDisplaySubSubSection.NameEN}
                    </div>

                    <div className={cssChoiceContent.divSubSubDividerBar}/>
                    
                    <div className={cssChoiceContent.divSubSubTitle}>
                        {mobjDisplaySubSubSection.NameCN}
                    </div>
                </div>

                <div className={cssChoiceContent.divInstructionArea}>
                    {props.LUInfo.Instruction}
                </div>
            </div>
        )
    } // end of RenderSubSubTitleAreaWrapper

    /*===========================================
    summary: Render SubSubToolArea 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderSubSubToolAreaWrapper(LUCatSeqNo)
    {
        if (parseInt(LUCatSeqNo) === window.gDCPLUEnum.PracticeReadingComprehension)
        {
            return (
                <div className={cssChoiceContent.divSubSubToolArea}>
                    {RenderSubSubTitleAreaWrapper()}
                    {RenderScoreToolAreaWrapper()}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderSubSubToolAreaWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssChoiceContent.divContent}>
                    {RenderSubSubToolAreaWrapper(props.LUInfo.LUCatSeqNo)}
                   
                    {RenderQuestionAreaWrapper(props.LUInfo.LUCatSeqNo)} 
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssChoiceContent.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper
    
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default ChoiceContent